import { isProductionModeOn, PROD_API_URL } from "./productionMode";

/** The API this build talks to, or production when staff switched it (ENG-2040). */
export const getApiUrl = () => {
  return isProductionModeOn() ? PROD_API_URL : process.env.API_URL;
};
